export default "__VITE_ASSET__CghRuKGD__"